import QuestionMarkCircleOutlineIcon from "@pingux/mdi-react/QuestionMarkCircleOutlineIcon";
import { Box, IconButton, PopoverMenu, Item, Menu, Icon } from "@pingux/astro";
import { headerSX } from "./HeaderSX";

interface DropdownProps {
  items: { label: string; url: string }[];
  onLogout?: () => void;
}

const HelpButton: React.FC<DropdownProps> = ({ items, onLogout }) => {
  const handleAction = (key?: unknown) => {
    if (key === "logout" && onLogout) {
      onLogout();
    }
  };

  return (
    <Box>
      <PopoverMenu>
        <IconButton aria-label="Help">
          <Icon
            icon={QuestionMarkCircleOutlineIcon}
            size="md"
            title={{
              name: "Help Icon",
            }}
            variant=""
          />
        </IconButton>
        <Menu onAction={onLogout ? handleAction : undefined}>
          {items.map((item) => (
            <Item
              as="a"
              variant="a"
              key={item?.url}
              target="_blank"
              href={item?.url}
              sx={headerSX.supportLinks}
              aria-label={item?.label}
            >
              {item?.label}
            </Item>
          ))}
          {onLogout && (
            <Item
              key="logout"
              sx={headerSX.supportLinks}
              aria-label="Logout"
            >
              Logout
            </Item>
          )}
        </Menu>
      </PopoverMenu>
    </Box>
  );
};

export default HelpButton;
